import { createFileRoute } from '@tanstack/react-router'

import { DuplicateInstrumentsScreen } from './-components/duplicate-instruments-screen.tsx'

export const Route = createFileRoute('/transaction-monitoring/duplicate-ach')({
  component: () => <DuplicateInstrumentsScreen page="duplicate-ach" />
})
